export { useResourcesPageAnalytics } from './use-resources-page-analytics';
export { useResourcesPageUIAnalytics } from './use-resources-page-ui-analytics';
